import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';

import React from 'react';
import Styles from './styles.js';
const WhyUs = ({ title, heading1, detail1, heading2, detail2, heading3, detail3, img1, img2, img3, bg, spacing }) => {
  return (
    <>
      {bg == 'none' ? (
        <div
          className={
            spacing
              ? 'lg:container px-4  lg:px-4 xl:px-4 2xl:px-5 mx-auto pt-0 text-light  '
              : 'lg:container mx-auto pt-4 px-6 lg:px-3 xl:px-4 2xl:px-5 text-light  '
          }>
          <div className="">
            <HeadingSection title={title} />
          </div>

          <div className="lg:container mx-auto px-6 px-lg-4 xl:px-3 2xl:px-5">
            <div className="grid  md:grid-cols-12 grid-cols-1 gap-x-12 pt-2 mt-2 pb-3 px-2 md:px-5 lg:px-3 xl:px-4 2xl:px-5 justify-center">
              <div className="lg:col-span-4 md:col-span-6 px-4 lg:px-0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img1} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5 className="fs-24-30 fw-400 mt-4 mb-2" style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                      {heading1}
                    </h5>
                    <p className="my-3 text-base leading-[28px] " style={{ fontFamily: 'Josefin Sans', color: 'rgb(94, 94, 94)' }}>
                      {detail1}
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-4 md:col-span-6 px-4 lg:px-0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img2} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5
                      className="   fs-24-30  fw-400 mt-4 mb-2"
                      style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                      {heading2}
                    </h5>
                    <p className="my-3 text-base leading-[28px]" style={{ fontFamily: 'Josefin Sans', color: 'rgb(94, 94, 94)' }}>
                      {detail2}
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-4 md:col-start-4 md:col-span-6 px-4 lg:0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img3} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5 className=" fs-24-30 fw-400 mt-6 mb-2" style={{ fontFamily: 'Josefin Sans', color: '#1b1b1b' }}>
                      {heading3}
                    </h5>
                    <p className="my-3 text-base leading-[28px] " style={{ fontFamily: 'Josefin Sans', color: 'rgb(94, 94, 94)' }}>
                      {detail3}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full pt-4 text-light " style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
          <div>
            <HeadingSection title={title} bgcolor="black" />
          </div>

          <div className="lg:container px-6 mx-auto  lg:px-4 xl:px-3 2xl:px-5">
            <div className="grid  md:grid-cols-12 grid-cols-1 gap-x-12 pt-2 mt-2 pb-3 md:px-5 px-4 lg:px-0 justify-center">
              <div className="lg:col-span-4 md:col-span-6 px-4 lg:px-0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img1} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5
                      className="fs-24-30 font-normal mt-4 mb-2"
                      style={{ fontFamily: 'Josefin Sans', color: '#f7f7f7' }}>
                      {heading1}
                    </h5>
                    <p className="my-3 fs-16-24 " style={{ fontFamily: 'Josefin Sans', color: '#a4a4a4' }}>
                      {detail1}
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-4 md:col-span-6 px-4 lg:px-0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img2} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5
                      className="   fs-24-30  fw-400 mt-4 mb-2"
                      style={{ fontFamily: 'Josefin Sans', color: '#f7f7f7' }}>
                      {heading2}
                    </h5>
                    <p className="my-3 fs-16-24" style={{ fontFamily: 'Josefin Sans', color: '#a4a4a4' }}>
                      {detail2}
                    </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-4 md:col-start-4 md:col-span-6  px-4 lg:px-0">
                <div className="  bg-transparent">
                  <img loading="lazy" src={img3} className="h-full w-full rounded-full" alt="..." />
                  <div className="flex flex-col justify-center items-center text-center">
                    <h5 className=" fs-24-30 fw-400 mt-6 mb-2" style={{ fontFamily: 'Josefin Sans', color: '#f7f7f7' }}>
                      {heading3}
                    </h5>
                    <p className="my-3 fs-16-24 " style={{ fontFamily: 'Josefin Sans', color: '#a4a4a4' }}>
                      {detail3}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Styles />
    </>
  );
};

export default WhyUs;
